'use strict';

module.exports = function (marty) {
  marty.autoDispatch = require('./autoDispatch');
  marty.ActionCreators = require('./actionCreators');
  marty.createActionCreators = require('./createActionCreatorsClass');
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/marty-lib/modules/action-creators/index.js
// module id = ORPN
// module chunks = 88